var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Card, Image, Tag } from '@philips-internal/oswald-ui-components';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import checkIcon from '../../assets/images/global/check-green.svg';
import PendingUrgentSVG from '../../assets/images/icons/Urgent.svg';
import TASK_ITEM_STATUS from '../../constants/task-item-status';
import { TaskListCardUtils } from '../../util/task-list-card-utils';
import TaskListSideBarCardAPI from './task-list-side-bar-card-api';
import './task-list-side-bar-card.css';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
let TaskListSideBarCard = class TaskListSideBarCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        ...this.props
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener,
        status: string,
        taskType: string,
    }; }
    renderStatusIcon(status) {
        return (React.createElement(Image, { src: this.getStatusIcon(status), className: 'task-list-side-bar-card-status-icon', alt: `${status}-icon` }));
    }
    getStatusIcon(status) {
        const PendingNormalStaticPath = '/static/assets/icons/warning.svg';
        switch (status) {
            case TASK_ITEM_STATUS.COMPLETED: return checkIcon;
            case TASK_ITEM_STATUS.PENDING_NORMAL: return PendingNormalStaticPath;
            case TASK_ITEM_STATUS.PENDING_URGENT: return PendingUrgentSVG;
            default: return '';
        }
    }
    renderTaskListSideBarCard() {
        const { taskType, status, taskEventType } = this.props;
        const title = MessageService.translate(TaskListCardUtils.getTaskExpression(taskType));
        const isBlocked = status === TASK_ITEM_STATUS.BLOCKED;
        const blockExpression = MessageService.translate('patient.blocked');
        const preparationExpression = MessageService.translate(TaskListCardUtils.getExpressionForTaskTag(taskEventType));
        return (React.createElement("div", { className: 'task-list-side-bar-card-container' },
            React.createElement("div", { className: 'task-list-side-bar-card-content' },
                React.createElement("div", { className: 'task-list-side-bar-card-title' }, title),
                React.createElement("div", null,
                    React.createElement("div", { className: 'schedule-tasks-progress-card-task-process-type' },
                        React.createElement(Tag, { value: preparationExpression, formatters: {} }),
                        isBlocked ? React.createElement("span", { className: 'task-list-side-bar-card-blocked' }, blockExpression) : this.renderStatusIcon(status))))));
    }
    render() {
        const { status } = this.props;
        const isBlocked = status === TASK_ITEM_STATUS.BLOCKED;
        return (React.createElement(Card, { className: `card-appointments-tasks${isBlocked ? '__blocked' : ''}`, key: generateUUID(), onClick: () => this.handleClick(), selectionType: SelectionType.NONE, transparent: true, uuid: generateUUID(), width: 12 },
            React.createElement("div", { className: 'task-list-side-bar-card', onClick: () => this.handleClick() }, this.renderTaskListSideBarCard())));
    }
};
TaskListSideBarCard = __decorate([
    AwesomeComponent({ api: TaskListSideBarCardAPI, type: ComponentType.DATA_DISPLAY })
], TaskListSideBarCard);
export default TaskListSideBarCard;
//# sourceMappingURL=task-list-side-bar-card.js.map